import type { FormValues } from '../types/form'

export const enum FormFieldNames {
	Email = 'email',
	Password = 'password',
	AutoLogin = 'autoLogin',
}

export const enum LoginSumbitErrors {
	Generic = 'generic',
	Email = 'email',
	Password = 'password',
}

export const enum FormErrorTypes {
	Required = 'required',
	Root = 'root',
	MaxLength = 'maxLength',
	Pattern = 'pattern',
	Validate = 'validate',
}

export const enum FormFieldIds {
	Email = 'login-form-email-input',
	Password = 'login-form-password-input',
	AutoLogin = 'login-form-autoLogin-input',
	LoginButton = 'login-form-submit-button',
}

export const defaultValues: FormValues = {
	autoLogin: true,
	password: '',
	email: '',
}

export const RECOVERY_PASSWORD_URL_LEGACY = '/resetpassword'
export const RECOVERY_PASSWORD_URL = '/recovery-password'

export const enum TestIds {
	RecoveryPasswordLink = 'login.recoveryPasswordLink.recoveryPassword',
	RegistryLink = 'login.registryLink.createAccount',
	LoginButton = 'login.loginButton.login',
	EmailInput = 'login.emailInput.text',
	PasswordInput = 'login.passwordInput.text',
	AutoLoginCheckbox = 'login.autoLoginCheckbox.loginPersists',
	CreateAccountButton = 'login.createAccountButton.createAccount',
}
